<template>
  <div>
    <div class="d-flex justify-content-center mt-2" v-if="loading">
      <b-spinner variant="primary" />
    </div>
    <b-row>
      <b-col
        md="2"
        class="mb-1"
        v-for="(file, index) in GET_PTO_FOR_GOOD_ONE.photos"
        :key="index"
        @click="src = file.file"
        v-b-modal.file-preview
      >
        <FileItem :file="file" :index="index" @deleteFile="deleteFile" />
      </b-col>
    </b-row>
    <div style="border: #b9b9c3 2px dashed" class="mb-2 p-50">
      <b-row>
        <template v-for="(file, index) in files">
          <FileItem
            :file="file"
            :key="index"
            upload
            @removeItem="removeItem"
            :index="index"
            :loading="uploadLoading"
          />
        </template>
      </b-row>

      <hr v-if="filesData.length" />

      <div
        @drop.prevent="onDropHandler"
        @dragstart="dragHandler"
        @dragleave.prevent="dragLeaveHandler"
        @dragover="dragHandler"
      >
        <label for="file" class="d-flex justify-content-center p-1">
          <feather-icon class="mr-50" icon="PaperclipIcon" size="16" />
          {{$t('general.select')}}
        </label>
        <input
          id="file"
          type="file"
          multiple
          class="d-none"
          @input="onChange"
        />
      </div>
    </div>
    <div
      class="d-flex justify-content-end"
      v-if="filesData.length && uploadbutton"
    >
      <b-button variant="success" @click="upload()" :disabled="uploadLoading">
        <feather-icon icon="UploadIcon" /> Upload</b-button
      >
    </div>

    <PreviewFile :src="src" id="file-preview" />
  </div>
</template>

<script>
import { BRow, BCol, BAvatar, BButton, BSpinner } from "bootstrap-vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import http from "@/libs/axios";
import FileItem from "./components/FileItem.vue";
import PreviewFile from "../PreviewFile.vue";

export default {
  props: {
    object_id: {
      type: Number,
      default: 1,
    },
    // content_type: {
    //   type: Number,
    //   default: 1,
    // },
    uploadbutton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      src: "",
      loading: false,
      uploadLoading: false,
      drag: false,
      files: [],
      filesData: [],
    };
  },

  computed: {
    // ...mapGetters("files", ["getAttachments"]),
    ...mapGetters("pto", ["GET_PTO_FOR_GOOD_ONE"]),
  },
  methods: {
    ...mapActions("files", ["FETCH_ATTACHMENTS", "DELETE_ATTACHMENT"]),
    // ...mapMutations("files", ["SET_ATTACHMENT", "SET_ATTACHMENTS"]),
    ...mapActions("pto", [
      "FETCH_PTO_FOR_GOOD_LIST",
      "UPDATE_PTO_FOR_GOOD",
      "FETCH_PTO_FOR_GOOD_ONE",
      "DELETE_PTO_FOR_GOOD_IMAGE",
    ]),
    onPasteFile(e) {
      if (e.clipboardData) {
        let item = e.clipboardData.files[0];
        if (item) {
          this.fileReader(item);
        }
      }
    },
    async upload(objectId) {
      if (!this.filesData.length) {
        return;
      }

      return new Promise(async (resolve, reject) => {
        try {
          this.uploadLoading = true;

          for (let i = 0; i < this.filesData.length; i++) {
            const formData = new FormData();

            formData.append("files", this.filesData[i]);

            const response = await http.patch(
              `/contract/pto_for_good/${this.object_id}/`,
              formData,
              {
                onUploadProgress: (progressEvent) => {
                  this.files[i].progress = Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  );
                },
              }
            );

            this.files[i].isFinished = false;
            this.FETCH_PTO_FOR_GOOD_ONE(this.object_id);
            this.$emit("refresh");
            // this.SET_ATTACHMENT(response.data);
          }

          this.files = [];

          this.filesData = [];

          this.uploadLoading = false;
          resolve();
          this.$_okToast();
        } catch (err) {
          this.uploadLoading = false;
          this.$_errToast('Error');
          reject();
        }
      });
    },
    onChange(event) {
      if (!event.target.files.length) {
        return;
      }
      const files = [...event.target.files];
      files.forEach((file) => {
        this.fileReader(file);
      });
    },
    fileReader(file) {
      if (!file) {
        return;
      }
      const reader = new FileReader();

      reader.onload = (ev) => {
        const src = ev.target.result;

        this.files.push({
          file: src,
          title: file.name,
          type: file.type,
          progress: 0,
          isFinished: true,
        });

        this.filesData.push(file);
      };

      reader.readAsDataURL(file);
    },
    removeItem(index) {
      this.files.splice(index, 1);
      this.filesData.splice(index, 1);
    },

    async deleteFile(id) {
      await this.DELETE_PTO_FOR_GOOD_IMAGE(id);
      await this.FETCH_PTO_FOR_GOOD_ONE(this.object_id);
      this.$emit("refresh");
    },

    onDropHandler(event) {
      event.preventDefault();

      this.drag = false;

      const files = [...event.dataTransfer.files];

      files.forEach((file) => {
        this.fileReader(file);
      });
    },
    dragHandler(event) {
      event.preventDefault();
      this.drag = true;
    },
    dragLeaveHandler() {
      this.drag = false;
    },
  },

  async mounted() {
    if (!this.object_id) {
      console.log("object_id not difined");
      return;
    }
    try {
      this.loading = true;
      await this.FETCH_ATTACHMENTS({
        content_type: this.content_type,
        object_id: this.object_id,
        page_size: 18,
      });
      this.loading = false;
    } catch (err) {
      this.loading = false;
    }
  },

  destroyed() {
    // this.SET_ATTACHMENTS({
    //   results: [],
    // });
  },

  components: {
    BAvatar,
    BRow,
    BCol,
    BButton,
    BSpinner,
    FileItem,
    PreviewFile,
  },
};
</script>
